import React, { useEffect, useRef, useState, useLayoutEffect, useContext } from "react";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import {
  DrawProp,
  colorList,
  convertOrigin,
  hexToRgba,
  brushList,
  sizeList,
} from "bodycodi/cmap/app/components/common/imageEditor/imageEditer";

// utils
import { isEmpty } from "../../../js/common";

// assets
import eraser from "bodycodi/cmap/app/img/eraser.png";
import eraserActive from "bodycodi/cmap/app/img/eraser-active.png";
import drawActive from "bodycodi/cmap/app/img/draw-active.png";
import drawDisable from "bodycodi/cmap/app/img/draw-disable.png";
import fontSize1 from "bodycodi/cmap/app/img/font-size1.png";
import fontSize2 from "bodycodi/cmap/app/img/font-size2.png";
import fontSize3 from "bodycodi/cmap/app/img/font-size3.png";
import fontSize4 from "bodycodi/cmap/app/img/font-size4.png";
import { Brush } from "bodycodi/cmap/app/svg/brush";

const createArray = (rows: number, columns: number) => {
  const arr = new Array(rows);
  for (let i = 0; i < rows; i++) {
    arr[i] = new Array(columns);
  }
  return arr;
};

const DrawControll = ({
  color,
  setColor,
  editor,
  activeObject,
  setMode1,
  setBrush,
  brush,
  setActiveObject,
}: DrawProp) => {
  const { dispatch } = useContext(DispatchContext);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [tip, setTip] = useState(false);
  const [mode, setMode] = useState("");
  const pickColor = useRef<HTMLDivElement>(null);
  const pickerBtn = useRef<HTMLDivElement>(null);
  const controller = useRef<HTMLDivElement>(null);
  const brushPicker = useRef<HTMLDivElement>(null);
  const eraserBtn = useRef<HTMLDivElement>(null);
  const sizePicker = useRef<HTMLDivElement>(null);
  const sisePickerBtn = useRef<HTMLDivElement>(null);
  const wrap = useRef<HTMLDivElement>(null);
  const [imageData, setImageData] = useState("");
  const colrPicker = useRef<HTMLDivElement>(null);
  const drawBtn = useRef<HTMLDivElement>(null);
  const [openSize, setOpenSize] = useState(false);
  const [pickFont, setPickFont] = useState({ fontSize: 14 });
  const [eraseAllActive, setEraseAllActive] = useState<boolean>(false);

  useEffect(() => {
    wrap.current?.classList.add("open");
    openColorPicker();
  }, []);

  useEffect(() => {
    if (mode === "eraser") {
      setTip(true);
    } else {
      setTip(false);
    }
  }, [mode, activeObject]);

  useEffect(() => {
    if (activeObject.type === "path") {
      editor.setBrush({
        color: color,
      });
    } else {
      editor.changeTextStyle(activeObject.id, {
        fill: color,
      });
    }
  }, [color]);

  useEffect(() => {
    editor.setBrush({
      width: brush,
    });
  }, [brush]);

  useEffect(() => {
    pickColor.current!.style.transform = "scale(0)";
    pickColor.current!.style.webkitTransform = "scale(0)";
    pickColor.current!.style.transition =
      "transform 0.1s ease, -webkit-transform 0.1s ease, background-color 100ms ease";
    const position = convertOrigin(colorList.indexOf(color));
    setTimeout(() => {
      pickColor.current!.style.transformOrigin = `${position.x + 20}px ${position.y + 20}px`;
      pickColor.current!.style.transform = "scale(1)";
      pickColor.current!.style.backgroundColor = color === "#000000" ? "#373737" : color;
    }, 150);
  }, [color]);

  useEffect(() => {
    editor.changeTextStyle(activeObject.id, {
      fontSize: pickFont.fontSize,
    });
  }, [pickFont]);

  useLayoutEffect(() => {
    document.addEventListener("click", handleOutSideClick);
    return () => {
      document.removeEventListener("click", handleOutSideClick);
    };
  }, []);

  const setColorPicker = (d: string) => () => {
    setColor(d);
    setOpen(false);

    setTimeout(() => {
      clickDraw(d);
    }, 300);
  };

  const setSizePicker = (d: any) => () => {
    setPickFont(d);
  };

  const openColorPicker = () => {
    setOpen(!open);
    setMode("picker");
    editor.stopDrawingMode();
  };

  const clickDraw = (d: any) => {
    if (open1) {
      setMode("");
      editor.stopDrawingMode();
      setOpen1(false);
    } else {
      setMode("draw");
      editor.stopDrawingMode();
      editor.startDrawingMode("FREE_DRAWING");
      editor.setBrush({
        width: brush,
        color: d,
      });
      setOpen1(true);
    }
  };

  const clickDeletePath = () => {
    setMode("eraser");
    editor.stopDrawingMode();
    if (mode === "eraser") {
      if (!isEmpty(activeObject)) {
        setTip(false);
        if (activeObject.type === "path") {
          editor.removeObject(activeObject.id);
          setActiveObject({});
        } else {
          editor.removeObject(activeObject.id);
          setActiveObject({});
        }
      } else {
      }
    } else {
    }
  };

  useEffect(() => {
    if (!editor.isEmptyUndoStack()) {
      setEraseAllActive(true);
    } else {
      setEraseAllActive(false);
    }
  }, [editor.isEmptyUndoStack()]);

  const clear = () => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: "모두 지우기",
        cancleYn: "D",
        redYn: true,
        redButtonLabel: "지우기",
        body: `편집한 그림을 \n 모두 지울까요?`,
        cancelAlert: () => {
          return;
        },
        closeAlert: () => {
          setActiveObject({});
          editor.clearObjects();

          setTimeout(() => {
            editor.clearRedoStack();
            editor.clearUndoStack();
          }, 200);
        },
        alert: true,
      },
    });
  };

  const handleOutSideClick = (e: any) => {
    const node = controller.current!;
    const canvas = document.querySelector(".tui-image-editor-canvas-container");
    const picker = colrPicker.current;

    if (
      (!node || !node.contains(e.target)) &&
      !canvas?.contains(e.target) &&
      !picker?.contains(e.target)
    ) {
      //editor.stopDrawingMode();
    }
  };

  return (
    <div className="custon-editor-feature-detail-wrap" ref={wrap}>
      <div className="color-picker-wrap" ref={controller}>
        {open && (
          <ColorPicker
            colrPicker={colrPicker}
            colorList={colorList}
            setColorPicker={setColorPicker}
            color={color}
            setMode={setMode}
            setOpen={setOpen}
            pickerBtn={pickerBtn}
          />
        )}
        {open1 && (
          <BrushPicker
            brush={brush}
            color={color}
            setBrush={setBrush}
            brushPicker={brushPicker}
            setOpen1={setOpen1}
            drawBtn={drawBtn}
          />
        )}
        {openSize && (
          <SizePicker
            pickFont={pickFont}
            color={color}
            setSizePicker={setSizePicker}
            sizePicker={sizePicker}
            setOpenSize={setOpenSize}
            sisePickerBtn={sisePickerBtn}
            setMode={setMode}
          />
        )}
        <div className="draw-controller flex">
          <div
            className={"color-picker" + (mode === "picker" ? " active" : "")}
            onClick={openColorPicker}
            ref={pickerBtn}
          >
            <div className="pick-color" ref={pickColor}></div>
          </div>
          <div className="draw-controller-btn" ref={drawBtn} onClick={() => clickDraw(color)}>
            <img src={mode === "draw" ? drawActive : drawDisable} />
          </div>

          <div className="draw-controller-eraser">
            <div className="draw-controller-btn margin" onClick={clickDeletePath}>
              <img src={eraserActive} className={mode === "eraser" ? "" : "none"} />
              <img src={eraser} className={mode !== "eraser" ? "" : "none"} />
              <Tip open={tip} setOpen={setTip} />
            </div>
            <div className="slash"></div>
            <div
              className={"all-delete" + (mode === "eraser" || eraseAllActive ? " active" : "")}
              onClick={mode === "eraser" || eraseAllActive ? clear : () => {}}
            >
              모두지우기
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

type SizePicker = {
  pickFont: any;
  setSizePicker: Function;
  color: string;
  sizePicker: any;
  setOpenSize: Function;
  sisePickerBtn: any;
  setMode: Function;
};

const SizePicker = ({
  pickFont,
  color,
  setSizePicker,
  sizePicker,
  setOpenSize,
  sisePickerBtn,
  setMode,
}: SizePicker) => {
  useLayoutEffect(() => {
    document.addEventListener("click", handleOutSideClickPickerSize);
    return () => {
      document.removeEventListener("click", handleOutSideClickPickerSize);
      setMode("");
    };
  }, []);

  const handleOutSideClickPickerSize = (e: any) => {
    const node = sizePicker.current!;
    const btn = sisePickerBtn.current!;

    if ((!node || !node.contains(e.target)) && !btn.contains(e.target)) {
      setOpenSize(false);
    }
  };

  const sizeListComponents = sizeList.map((d: any) => {
    const lineColor = d.fontSize === pickFont.fontSize ? "#ffffff" : "#000000";
    const lineColor1 = d.fontSize === pickFont.fontSize ? "#000000" : "#ffffff";
    const styles: any = { color: lineColor, fontSize: d.fontSize + "px", fontFamily: "Medium" };
    let rgba: any;
    let className = "";
    if (!isEmpty(lineColor)) {
      rgba = hexToRgba(lineColor, 0.1);
    }
    if (!isEmpty(color)) {
      if (d.fontSize === pickFont.fontSize) {
        className = " active";
      }
    }
    return (
      <div className={"size-btn" + className} onClick={setSizePicker(d)}>
        {d.fontSize === 14 && <img src={fontSize1} />}
        {d.fontSize === 24 && <img src={fontSize2} />}
        {d.fontSize === 38 && <img src={fontSize3} />}
        {d.fontSize === 48 && <img src={fontSize4} />}
      </div>
    );
  });

  return (
    <div className="color-picker-pop" ref={sizePicker}>
      <div className="color-wrap brush-picker">{sizeListComponents}</div>
    </div>
  );
};

type BrushPickerProp = {
  brushPicker: any;
  brush: number;
  setBrush: Function;
  color: string;
  setOpen1: Function;
  drawBtn: any;
};

const BrushPicker = ({
  brushPicker,
  brush,
  setBrush,
  color,
  drawBtn,
  setOpen1,
}: BrushPickerProp) => {
  const [style, setStyle] = useState({});

  useLayoutEffect(() => {
    document.addEventListener("click", handleOutSideClickBrushPicker);
    return () => {
      document.removeEventListener("click", handleOutSideClickBrushPicker);
    };
  }, []);

  const handleOutSideClickBrushPicker = (e: any) => {
    const node = brushPicker.current!;
    const btn = drawBtn.current!;

    if ((!node || !node.contains(e.target)) && !btn.contains(e.target)) {
      setOpen1(false);
    }
  };

  const clickBrush = (n: number) => () => {
    setBrush(n);
    setOpen1(false);
  };

  const sizeListComponents = brushList.map((d: any, i: number) => {
    const lineColor = d === brush ? "#ffffff" : "#000000";
    const styles: any = { color: lineColor, fontSize: d.fontSize + "px", fontFamily: "Medium" };
    let rgba: any;
    let className = "";
    if (!isEmpty(lineColor)) {
      rgba = hexToRgba(lineColor, 1);
    }
    if (!isEmpty(color)) {
      if (d === brush) {
        className = " active";
      }
    }
    return (
      <div className={"brush-btn" + className} style={styles} onClick={clickBrush(d)} key={i}>
        <Brush size={d} color={"#ffffff"} />
      </div>
    );
  });

  return (
    <div className="color-picker-pop" ref={brushPicker}>
      <div className="color-wrap brush-picker">{sizeListComponents}</div>
    </div>
  );
};

type ColorPickerProp = {
  colrPicker: any;
  colorList: Array<any>;
  setColorPicker: Function;
  color: string;
  setOpen: Function;
  pickerBtn: any;
  setMode: Function;
};

const ColorPicker = ({
  colrPicker,
  colorList,
  setColorPicker,
  color,
  pickerBtn,
  setOpen,
  setMode,
}: ColorPickerProp) => {
  const [colorList2d, setColorList2d] = useState<any>([]);
  const { dispatch } = useContext(DispatchContext);

  useEffect(() => {
    let colorList2d1;
    const width = colrPicker.current!.clientWidth - 40;
    const length = Math.floor(width / 52);
    const left = colorList.length % length;
    const rows = Math.ceil(colorList.length / length);
    colorList2d1 = createArray(1, colorList.length);
    for (let i = 0; i < colorList.length; i++) {
      const data = colorList[i];
      colorList2d1[0][i] = { color: data, empty: false };
    }
    setColorList2d([...colorList2d1]);
  }, []);

  useLayoutEffect(() => {
    document.addEventListener("click", handleOutSideClickPicker);
    return () => {
      document.removeEventListener("click", handleOutSideClickPicker);
      setMode("");
    };
  }, []);

  const handleOutSideClickPicker = (e: any) => {
    const node = colrPicker.current!;
    const btn = pickerBtn.current!;

    if ((!node || !node.contains(e.target)) && !btn.contains(e.target)) {
      setOpen(false);
    }
  };

  const colorListComponents = colorList2d.map((d: any) => {
    const color1 = d.map((d1: any) => {
      if (!d1.empty) {
        const className =
          color === d1.color ? (d1.color === "#FFFFFF" ? " on-black" : " on-white") : "";

        return (
          <div
            className={"color" + className}
            style={{ backgroundColor: d1.color === "#000000" ? "#373737" : d1.color }}
            onClick={setColorPicker(d1.color)}
          />
        );
      } else {
        return <div className="empty"></div>;
      }
    });
    return <div className="color-wrap">{color1}</div>;
  });

  return (
    <div className="color-picker-pop" ref={colrPicker}>
      {colorListComponents}
    </div>
  );
};

type tip = {
  open: boolean;
  setOpen: Function;
};

const Tip = ({ open, setOpen }: tip) => {
  useEffect(() => {}, [open]);

  return (
    <>
      {open && (
        <div className="delete-tip open">
          지우고 싶은 영역을 선택 후<br />
          <span>다시 지우개를 누르면 삭제됩니다</span>
        </div>
      )}
    </>
  );
};

export default DrawControll;
